import styled, { css } from "styled-components";
import { type BorderProps, type WidthProps, type SpaceProps, border, width, space } from "styled-system";
import * as Button from "./Button";
import { toyotaTheme as theme } from "../../themes/toyotaTheme";

/**
 * A CTA containing an optional red button with an icon.
 * Currently used in Build and USC.
 */

export const CtaIconButton = styled.a<
    WidthProps &
        BorderProps &
        SpaceProps & {
            hasIcon?: boolean;
            notClickable?: boolean;
            disabled?: boolean;
            light?: boolean;
            redBorder?: boolean;
        }
>`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: flex-start;
    min-width: 160px;
    max-width: 100%;
    min-height: 4.4rem;
    padding: 0;
    line-height: 2.4rem;
    color: ${theme.textColor.button};
    white-space: nowrap;
    border: 1px solid ${({ redBorder }) => (redBorder ? theme.colors.primary : theme.colors.grey2)};
    border-radius: 100px;
    ${space};
    ${width};
    ${border};

    &:hover,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${theme.textColor.button};
    }

    ${({ light }) =>
        light &&
        css`
            background-color: ${theme.colors.lightest};
            border: 1px solid ${theme.colors.grey2};
        `};

    ${({ notClickable }) =>
        notClickable &&
        css`
            pointer-events: none;
            cursor: auto;
        `};
    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${theme.color.grey4} !important;
        `};
`;

export const CtaIconLabel = styled.span`
    display: flex;
    flex-grow: 1;
    justify-content: center;
    max-width: 100%;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const CtaIconWrapper = styled(Button.CtaIconWrapper)<SpaceProps & { transparentBackground?: boolean }>`
    width: 30px;
    height: 30px;
    margin: 8px;
    margin-right: 0;
    ${space};
    background-color: ${({ transparentBackground }) => (transparentBackground ? "transparent" : theme.color.primary)};
    svg {
        margin-right: 0 !important;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        svg {
            margin-left: 0 !important;
        }
    }
`;
